import AudioRecorderActionTypes from '../action-types/audio-recorder';
import { initializeRecordingContext } from '../reducer-utils/audio-recorder';
const initializeState = () => {
    return {
        hasMicrophoneRestarted: false,
        isRestartingMicrophone: false,
        recordingContext: initializeRecordingContext(),
    };
};
const INITIAL_STATE = initializeState();
const audioRecorderReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AudioRecorderActionTypes.RESET_AUDIO_RECORDER_STATE:
            return Object.assign(Object.assign({}, state), initializeState());
        case AudioRecorderActionTypes.RESET_RECORDING_CONTEXT:
            return Object.assign(Object.assign({}, state), { recordingContext: initializeRecordingContext() });
        case AudioRecorderActionTypes.SET_HAS_MICROPHONE_RESTARTED:
            return Object.assign(Object.assign({}, state), { hasMicrophoneRestarted: action.payload });
        case AudioRecorderActionTypes.SET_IS_RESTARTING_MICROPHONE:
            return Object.assign(Object.assign({}, state), { isRestartingMicrophone: action.payload });
        case AudioRecorderActionTypes.SET_RECORDING_CONTEXT:
            return Object.assign(Object.assign({}, state), { recordingContext: action.payload });
        default:
            return state;
    }
};
export default audioRecorderReducer;
